import { FC, useEffect } from 'react';
import { translationCodes } from '../../../data/translations/translationModuleCodes';
import { PUBLIC_CUSTOM_PAGE_PATH } from '../../../utils/const';
import { AuthenticationEntry } from '../../app/sharedAppEntries';
import { setDocumentTitle } from '../../page/utils';
import { useTranslationAPI } from '../../translations';
import { useCustomPageDataQuery } from '../hooks';
import { CustomPageWidgets } from '../widgets';

window.requestIdleCallback &&
	window.requestIdleCallback(() => {
		AuthenticationEntry.preload();
	});

export const Home: FC = () => {
	const { translate } = useTranslationAPI();
	const { data } = useCustomPageDataQuery(PUBLIC_CUSTOM_PAGE_PATH.home);

	useEffect(() => {
		setDocumentTitle(translate(translationCodes.homePage));
	}, [translate]);

	return <CustomPageWidgets widgets={data} />;
};
